import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { EllipsisText } from '@labrav/common'
import { useStyles } from './ActivityFeed.styles'

interface ActivityFeedRowProps {
  icon: IconDefinition
  text: string
  actionLabel: string
  onAction: () => void
}

export const ActivityFeedRow: React.FC<ActivityFeedRowProps> = ({
  icon,
  text,
  actionLabel,
  onAction,
}) => {
  const { classes, cx } = useStyles()
  return (
    <div
      className={classes.row}
      role="button"
      tabIndex={0}
      onClick={onAction}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onAction()
        }
      }}
    >
      <div className={classes.rowIconContainer}>
        <FontAwesomeIcon icon={icon} className={classes.rowIcon} />
      </div>
      <EllipsisText text={text} className={classes.rowText} />
      <div className={cx(classes.rowAction, 'labra-row-action')}>
        <span className={classes.rowActionBtn}>{actionLabel}</span>
      </div>
    </div>
  )
}
